import { Component, ViewEncapsulation } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Country, GlobalizeLanguageService } from 'localization-utils';
import { ItemClickEvent } from 'devextreme/ui/select_box';

@Component({
  selector: 'nida-web-language-select-box',
  templateUrl: './language-select-box.component.html',
  styleUrls: ['./language-select-box.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: false,
})
export class LanguageSelectBoxComponent {
  public countries: Country[];
  private activeLanguage: string;

  constructor(private transService: TranslocoService, private globalizeLanguageService: GlobalizeLanguageService) {
    this.activeLanguage = this.transService.getActiveLang();
    this.countries = this.globalizeLanguageService.getCountries();
  }

  changeLanguage(langChangeEvent: ItemClickEvent) {
    const languageCode = langChangeEvent.itemData.LanguageCode;
    this.activeLanguage = languageCode;
    this.transService.setActiveLang(languageCode);
    this.globalizeLanguageService.setLanguage(languageCode);
    localStorage.setItem('language', languageCode);
  }

  getActiveLanguage() {
    return this.activeLanguage;
  }
}
